import { useState, useCallback } from "react";

import { useSnackbar } from "notistack";

import { useCurrentUserContext } from "../../../../contexts/CurrentUserContext";
import { useSendVerifyEmailNotificationMutation } from "../../../../gql/queries/generated/notificationQuery";
import { useTranslate } from "../../../../hooks/useTranslate";

import { DashboardInfobox } from "@/dashboard-design-system/Infobox";

export const VerifyEmailAlert = ({
  message,
  needToLinkBankAccount,
}: {
  message?: string;
  needToLinkBankAccount?: boolean;
}) => {
  const { t } = useTranslate();
  const { enqueueSnackbar } = useSnackbar();
  const { currentUser } = useCurrentUserContext();

  const [sendVerifyEmailNotificationMutation] = useSendVerifyEmailNotificationMutation();
  const [isLoading, setIsLoading] = useState(false);

  const sendVerifyEmailNotification = useCallback(async () => {
    setIsLoading(true);
    await sendVerifyEmailNotificationMutation();
    enqueueSnackbar(t("dashboard", "writeEmailModal.emailSent"), { vibe: "positive" });
    setIsLoading(false);
  }, [enqueueSnackbar, sendVerifyEmailNotificationMutation, t]);

  return (
    <DashboardInfobox
      vibe="warning"
      size="small"
      type="alert"
      buttonsProps={[
        {
          key: "view-requirement",
          children: <>{t("dashboard", "resend")}</>,
          onClick: sendVerifyEmailNotification,
          isLoading,
          inline: true,
        },
      ]}
    >
      {needToLinkBankAccount
        ? t("dashboard", "writeEmailModal.pleaseValidateYourEmailAndBank")
        : t("dashboard", "writeEmailModal.pleaseValidateYourEmail1")}
      <strong>({currentUser?.email})</strong>{" "}
      {message ? message : t("dashboard", "writeEmailModal.pleaseValidateYourEmail.reason")}{" "}
      {t("dashboard", "writeEmailModal.pleaseValidateYourEmail2")}
    </DashboardInfobox>
  );
};
